'use client';

import NutrientRanking from '@/components/NutrientRanking';

type Props = {
  title: string;
  value?: number;
  onClick?: () => void;
};

export default function NutrientGroupTitle({
  title,
  value,
  onClick = () => undefined,
}: Props) {
  return (
    <div
      onClick={() => null}
      className="mb-1 flex w-full items-center justify-between border-b pb-1 dark:border-gray-700"
    >
      <h2 className="text-xl font-bold capitalize leading-5">{title}</h2>

      {/* {value ? <Rating className="mr-1" value={value} /> : <></>} */}
    </div>
  );
}
